/* Extracted from Extend pets new updated code.html. Script blocks kept in original document order. */
(function(){
  var tiles = document.querySelectorAll('.ba-tile');
  var lb = document.getElementById('baLb');
  var lbVideo = document.getElementById('baLbVideo');
  var btnClose = lb ? lb.querySelector('.ba-lb-close') : null;
  if(!tiles.length || !lb || !lbVideo || !btnClose) return;

  var lastFocus = null;

  // Try to softly autoplay each tile's muted preview when it enters the viewport.
  // Playing all 9 at once would waste bandwidth, so we rely on IntersectionObserver
  // and pause anything that scrolls out of view.
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var v = en.target.querySelector('video');
        if(!v) return;
        if(en.isIntersecting){
          var p = v.play(); if(p && p.catch) p.catch(function(){});
        } else {
          try{ v.pause(); }catch(e){}
        }
      });
    }, {rootMargin:'80px 0px', threshold:0.25});
    tiles.forEach(function(t){ io.observe(t); });
  }

  function open(src){
    lastFocus = document.activeElement;
    lbVideo.setAttribute('src', src);
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden','false');
    document.body.classList.add('ba-lb-locked');
    var p = lbVideo.play(); if(p && p.catch) p.catch(function(){});
    setTimeout(function(){ btnClose.focus(); }, 50);
  }
  function close(){
    try{ lbVideo.pause(); }catch(e){}
    lbVideo.removeAttribute('src');
    lbVideo.load();
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden','true');
    document.body.classList.remove('ba-lb-locked');
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  tiles.forEach(function(t){
    t.addEventListener('click', function(){
      var src = t.getAttribute('data-src');
      if(src) open(src);
    });
  });
  btnClose.addEventListener('click', close);
  lb.addEventListener('click', function(e){ if(e.target === lb) close(); });
  document.addEventListener('keydown', function(e){
    if(lb.classList.contains('is-open') && e.key === 'Escape') close();
  });
})();

        (function(){
          var v = document.getElementById('parentsVideo');
          var b = document.getElementById('parentsMuteBtn');
          if(!v || !b) return;
          function sync(){
            var muted = v.muted;
            b.setAttribute('aria-pressed', muted ? 'true' : 'false');
            b.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
          }
          b.addEventListener('click', function(){
            v.muted = !v.muted;
            if(!v.muted){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }
            sync();
          });
          v.addEventListener('volumechange', sync);
          sync();
        })();
      

(function(){
  var INITIAL = 10;   // reviews shown on first load
  var BATCH = 8;      // reviews revealed per click
  var rows = Array.prototype.slice.call(document.querySelectorAll('#reviews .rv-list .rv-row'));
  var btn = document.getElementById('rvShowMore');
  // cntSpan removed, button text is static
  if(!rows.length || !btn) return;

  rows.forEach(function(r, i){ if(i >= INITIAL) r.classList.add('rv-hidden'); });
  updateBtn();

  btn.addEventListener('click', function(){
    var hidden = rows.filter(function(r){ return r.classList.contains('rv-hidden'); });
    hidden.slice(0, BATCH).forEach(function(r){ r.classList.remove('rv-hidden'); });
    updateBtn();
    // scroll the first newly-revealed row into view
    if(hidden.length){ hidden[0].scrollIntoView({behavior:'smooth', block:'start'}); }
  });

  function updateBtn(){
    var remain = rows.filter(function(r){ return r.classList.contains('rv-hidden'); }).length;
    if(remain === 0){
      btn.parentNode.style.display = 'none';
    } else {
      // button text stays 'See more'
    }
  }
})();

(function(){
  // ===================================================================
  // Multi-pack picker + Subscribe/One-Time toggle
  // Keeps the hidden form inputs (#buy-variant-id, #buy-selling-plan) and
  // the per-card displayed price/save copy in sync with the current
  // selection, so Add to Cart posts the exact pair Shopify will charge.
  // ===================================================================
  var optbox        = document.getElementById('optbox');
  var modeBtns      = optbox ? optbox.querySelectorAll('.pk-mode-btn') : [];
  var packCards     = optbox ? optbox.querySelectorAll('.pk-card')     : [];
  var variantInput  = document.getElementById('buy-variant-id');
  var sellingPlanInput = document.getElementById('buy-selling-plan');

  function fmt(n){ return '$' + Number(n).toFixed(2); }

  // Render each card's price + "save" text for the current mode.
  function renderCards(mode){
    packCards.forEach(function(card){
      var isSub = (mode === 'subscribe');
      var price = card.dataset[isSub ? 'subscribePrice' : 'onetimePrice'];
      var save  = parseFloat(card.dataset[isSub ? 'subscribeSave' : 'onetimeSave']);
      var off   = parseInt(card.dataset[isSub ? 'subscribeOff' : 'onetimeOff'], 10);

      var priceEl = card.querySelector('.pk-price');
      var saveEl  = card.querySelector('.pk-save');
      var ribbonVal = card.querySelector('.pk-ribbon-off .pk-off-val');
      var ribbonOff = card.querySelector('.pk-ribbon-off');

      if(priceEl) priceEl.textContent = fmt(price);
      if(saveEl){
        // Compare-at (strikethrough) price so buyers see the real-dollar savings
        // instead of a vague "You save $X" line.
        if(save > 0){
          var original = Number(price) + Number(save);
          saveEl.innerHTML = '<span class="pk-strike-amt">' + fmt(original) + '</span>' + (isSub ? '<span class="pk-strike-cycle">/mo</span>' : '');
        } else {
          saveEl.textContent = '';
        }
      }
      if(ribbonVal) ribbonVal.textContent = off + '%';
      if(ribbonOff) ribbonOff.style.display = (off > 0) ? '' : 'none';
    });
  }

  // Push the current card's variant_id + selling_plan into the form.
  function syncFormToSelection(){
    if(!optbox) return;
    var mode = optbox.getAttribute('data-mode');
    var card = optbox.querySelector('.pk-card.on');
    if(!card) return;

    if(variantInput) variantInput.value = card.dataset.variantId || '';

    if(sellingPlanInput){
      if(mode === 'subscribe' && card.dataset.sellingPlan){
        sellingPlanInput.value = card.dataset.sellingPlan;
        sellingPlanInput.disabled = false;
      } else {
        sellingPlanInput.value = '';
        sellingPlanInput.disabled = true; // omit from the POST body entirely
      }
    }

    console.log('[cart] selection:', card.dataset.pack + '-pack', mode,
      '→ variant', variantInput && variantInput.value,
      ', plan', (sellingPlanInput && !sellingPlanInput.disabled) ? sellingPlanInput.value : '(one-time, no plan)');
  }

  // --- purchase-type toggle (One-Time / Subscribe) ---
  modeBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var mode = btn.getAttribute('data-mode');
      optbox.setAttribute('data-mode', mode);
      modeBtns.forEach(function(b){
        var isOn = b === btn;
        b.classList.toggle('on', isOn);
        b.setAttribute('aria-selected', isOn ? 'true' : 'false');
      });
      renderCards(mode);
      syncFormToSelection();
      updateFloatPrice();
    });
  });

  // --- pack card picker ---
  packCards.forEach(function(card){
    card.addEventListener('click', function(){
      packCards.forEach(function(c){
        c.classList.remove('on');
        var input = c.querySelector('.pk-input');
        if(input) input.checked = false;
      });
      card.classList.add('on');
      var selfInput = card.querySelector('.pk-input');
      if(selfInput) selfInput.checked = true;
      syncFormToSelection();
      updateFloatPrice();
    });
  });

  // --- floating ATC price label (if present) ---
  function updateFloatPrice(){
    var faPrice = document.getElementById('fa-price');
    if(!faPrice || !optbox) return;
    var mode = optbox.getAttribute('data-mode');
    var card = optbox.querySelector('.pk-card.on');
    if(!card) return;
    var price = card.dataset[mode === 'subscribe' ? 'subscribePrice' : 'onetimePrice'];
    var title = (card.querySelector('.pk-title') || {}).textContent || '';
    var label = title + (mode === 'subscribe' ? ' — Subscribe' : ' — One-time');
    faPrice.innerHTML =
      '<span class="fa-now">$' + Number(price).toFixed(2) + '</span>' +
      '<span class="fa-label">' + label + '</span>';
  }

  // Initial render + sync so page-load state matches the default selection.
  if(optbox){
    renderCards(optbox.getAttribute('data-mode') || 'subscribe');
    syncFormToSelection();
    updateFloatPrice();
  }

  // thumbnails
  var thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){ x.classList.remove('on'); });
      t.classList.add('on');
    });
  });

  // accordions (buy box + faq)
  function bindAcc(itemSel, qSel){
    document.querySelectorAll(itemSel).forEach(function(item){
      var q = item.querySelector(qSel);
      if(!q) return;
      q.setAttribute('tabindex','0');
      q.setAttribute('role','button');
      function t(){ item.classList.toggle('open'); }
      q.addEventListener('click', t);
      q.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); t(); }
      });
    });
  }
  bindAcc('.faq-i', '.faq-q');

  // "Tell me about" tabs
  var tabs = document.querySelectorAll('.tab');
  var panes = document.querySelectorAll('.tabpane');
  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      var n = +t.dataset.tab;
      tabs.forEach(function(x){ x.classList.remove('on'); });
      panes.forEach(function(x,i){ x.classList.toggle('on', i === n); });
      t.classList.add('on');
    });
  });

  // promo bar carousel
  var pslides = document.querySelectorAll('.promo-slide');
  var parws = document.querySelectorAll('.promo-arw');
  var pi = 0;
  function setPromo(i){
    pi = (i + pslides.length) % pslides.length;
    pslides.forEach(function(s,n){ s.classList.toggle('on', n === pi); });
  }
  parws.forEach(function(a,n){
    a.addEventListener('click', function(){ setPromo(pi + (n === 0 ? -1 : 1)); });
  });
  if(pslides.length > 1){
    setInterval(function(){ setPromo(pi + 1); }, 6000);
  }

  // gallery: slides, dots, thumbnails, arrows, swipe
  var gslides = document.querySelectorAll('.gal-slide');
  var gdots   = document.querySelectorAll('.gal-dots button');
  var gthumbs = document.querySelectorAll('.thumb');
  var gi = 0;
  function setGal(i){
    if(!gslides.length) return;
    gi = (i + gslides.length) % gslides.length;
    gslides.forEach(function(s,n){
      s.classList.toggle('on', n === gi);
      // Pause any video inside a slide that just became inactive
      if(n !== gi){
        var v = s.querySelector('video');
        if(v && !v.paused){ try{ v.pause(); }catch(e){} }
      }
    });
    gdots.forEach(function(d,n){ d.classList.toggle('on', n === gi); });
    gthumbs.forEach(function(t,n){
      var on = n === gi;
      t.classList.toggle('on', on);
      if(on && t.scrollIntoView) t.scrollIntoView({block:'nearest', inline:'nearest', behavior:'smooth'});
    });
  }
  gdots.forEach(function(d,n){ d.addEventListener('click', function(){ setGal(n); }); });
  gthumbs.forEach(function(t,n){ t.addEventListener('click', function(){ setGal(n); }); });
  var gp = document.querySelector('.gal-prev'), gn = document.querySelector('.gal-next');
  if(gp) gp.addEventListener('click', function(){ setGal(gi - 1); });
  if(gn) gn.addEventListener('click', function(){ setGal(gi + 1); });

  // swipe on the stage
  var stage = document.querySelector('.gal-stage'), sx = null;
  if(stage){
    stage.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
    stage.addEventListener('touchend', function(e){
      if(sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if(Math.abs(dx) > 40) setGal(gi + (dx < 0 ? 1 : -1));
      sx = null;
    }, {passive:true});
  }

  // arrow keys when the gallery has focus
  if(stage){
    stage.setAttribute('tabindex','0');
    stage.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ e.preventDefault(); setGal(gi - 1); }
      if(e.key === 'ArrowRight'){ e.preventDefault(); setGal(gi + 1); }
    });
  }

  // testimonial dots
  var dots = document.querySelectorAll('.vt-dots i');
  var arrows = document.querySelectorAll('.vt-arrow');
  var vi = 0;
  function setDot(i){
    vi = (i + dots.length) % dots.length;
    dots.forEach(function(d,n){ d.classList.toggle('on', n === vi); });
  }
  arrows.forEach(function(a,n){
    a.addEventListener('click', function(){ setDot(vi + (n === 0 ? -1 : 1)); });
  });
  dots.forEach(function(d,n){ d.addEventListener('click', function(){ setDot(n); }); });

  // ===== Shopify cart flow =====
  // Add to cart  → POST /cart/add.js → redirect to /cart
  // Buy it now   → POST /cart/add.js → redirect to /checkout
  // Variant ID, quantity and selling_plan come from the form's hidden
  // inputs, which pick() keeps in sync with the selected option.
  var buyForm = document.getElementById('buy-form');
  if(buyForm){
    // All cart requests target the Shopify storefront absolute URL so the page
    // works whether it's opened locally, on a staging domain, or on Shopify.
    var SHOP_ORIGIN = 'https://store.extendpets.com';

    var buyBtns = buyForm.querySelectorAll('button[data-cart-action]');
    // Sticky mobile bar and floating desktop pill live outside the form; include them.
    var stickyBtn = document.getElementById('btn-add-to-cart-sticky');
    var floatBtn  = document.getElementById('btn-add-to-cart-float');
    var allBtns = Array.prototype.slice.call(buyBtns);
    if(stickyBtn) allBtns.push(stickyBtn);
    if(floatBtn)  allBtns.push(floatBtn);

    // Remember which button triggered the submit so we know where to redirect.
    var pendingAction = 'cart';
    allBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        pendingAction = btn.getAttribute('data-cart-action') || 'cart';
      });
    });

    // Native cross-origin form fallback: used when the AJAX call is blocked
    // (CORS, file://, any off-Shopify origin). Browsers DO allow cross-origin
    // form POSTs — they only block cross-origin fetch/XHR without CORS headers.
    function nativeFormFallback(action){
      // Point the form at the absolute Shopify URL so the browser navigates there.
      buyForm.setAttribute('action', SHOP_ORIGIN + '/cart/add');
      buyForm.setAttribute('target', '_top');
      // Force urlencoded (the format Shopify's classic /cart/add handler expects).
      buyForm.setAttribute('enctype', 'application/x-www-form-urlencoded');
      // For "Buy it now" Shopify needs a field named "checkout" to redirect to /checkout.
      // We inject or remove it on the fly to match the clicked button.
      var existing = buyForm.querySelector('input[name="checkout"]');
      if(action === 'checkout'){
        if(!existing){
          var ck = document.createElement('input');
          ck.type = 'hidden';
          ck.name = 'checkout';
          ck.value = 'Checkout';
          buyForm.appendChild(ck);
        }
      } else if(existing){
        existing.parentNode.removeChild(existing);
      }
      // HTMLFormElement.submit() bypasses this submit listener → native POST + redirect.
      buyForm.submit();
    }

    buyForm.addEventListener('submit', function(e){
      e.preventDefault();

      // ===== Evidence collection: dump the EXACT form state right before submit =====
      var variantEl = document.getElementById('buy-variant-id');
      var planEl    = document.getElementById('buy-selling-plan');
      var qtyEl     = buyForm.querySelector('input[name="quantity"]');
      var selectedCard = document.querySelector('#optbox .pk-card.on');
      var selectedMode = (document.getElementById('optbox') || {}).dataset ? document.getElementById('optbox').dataset.mode : '';

      console.group('[cart] submit');
      console.log('selected offer    :', (selectedCard && selectedCard.dataset.pack ? (selectedCard.dataset.pack + '-pack') : '(none)') + ' / ' + selectedMode);
      console.log('variant input     :', variantEl, '-> value =', variantEl && variantEl.value);
      console.log('quantity input    :', qtyEl, '-> value =', qtyEl && qtyEl.value);
      console.log('selling_plan input:', planEl, '-> value =', planEl && planEl.value, ', disabled =', planEl && planEl.disabled);

      // Dump the fully-serialized FormData so you can compare it against the
      // Network tab byte-for-byte.
      var fd = new FormData(buyForm);
      var dump = {};
      fd.forEach(function(v, k){ dump[k] = v; });
      console.log('FormData payload  :', dump);
      console.log('pending action    :', pendingAction, '(cart | checkout)');
      console.groupEnd();

      // Disable buttons during the request to prevent double-submits.
      allBtns.forEach(function(b){ b.disabled = true; b.style.opacity = '0.75'; });

      // ⚠️ Payload shape UNCHANGED from the previous version so the error you saw
      //    is reproducible. We're logging now, not fixing. The Network tab is
      //    the next source of truth.
      fetch(SHOP_ORIGIN + '/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
      .then(function(res){
        // Always read the body so we can log the real Shopify response, not
        // just a thrown Error.
        return res.text().then(function(text){
          var parsed = null;
          try { parsed = JSON.parse(text); } catch(_){}
          console.group('[cart] Shopify response');
          console.log('HTTP status  :', res.status, res.statusText);
          console.log('response body:', parsed || text);
          console.groupEnd();
          if(!res.ok){
            throw new Error((parsed && (parsed.description || parsed.message)) || ('HTTP ' + res.status));
          }
          return parsed;
        });
      })
      .then(function(){
        window.location.href = SHOP_ORIGIN + (pendingAction === 'checkout' ? '/checkout' : '/cart');
      })
      .catch(function(err){
        console.warn('[cart] AJAX failed:', err && err.message);
        // Fall back to native cross-origin form POST ONLY if the AJAX hop
        // couldn't reach Shopify at all (network/CORS). Shopify-level 4xx
        // errors above re-throw and land here too — but in those cases we
        // want to see the alert, not silently redirect to a broken page.
        try {
          nativeFormFallback(pendingAction);
        } catch(fallbackErr){
          allBtns.forEach(function(b){ b.disabled = false; b.style.opacity = ''; });
          alert('Sorry, we couldn’t add that to your cart. ' + (err && err.message ? err.message : 'Please try again.'));
        }
      });
    });
  }

  // Trust video: autoplay muted + custom mute/unmute toggle (only control shown)
  var tv = document.getElementById('trustVideo');
  var tvBtn = document.getElementById('trustVideoMute');
  if(tv && tvBtn){
    // Keep it muted-autoplay on load (browsers require this for autoplay)
    tv.muted = true;
    // Nudge autoplay on devices that stalled it
    var tryPlay = function(){ var p = tv.play(); if(p && p.catch) p.catch(function(){}); };
    

    tvBtn.addEventListener('click', function(){
      tv.muted = !tv.muted;
      var muted = tv.muted;
      tvBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      tvBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      if(!muted){
        // user interacted, so sound should play
        var p = tv.play(); if(p && p.catch) p.catch(function(){});
      }
    });
  }

  // Love section video: autoplay muted + custom mute/unmute toggle
  var lv = document.getElementById('loveVideo');
  var lvBtn = document.getElementById('loveVideoMute');
  if(lv && lvBtn){
    lv.muted = true;
    var tryPlayLv = function(){ var p = lv.play(); if(p && p.catch) p.catch(function(){}); };
    

    lvBtn.addEventListener('click', function(){
      lv.muted = !lv.muted;
      var muted = lv.muted;
      lvBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      lvBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      if(!muted){
        var p = lv.play(); if(p && p.catch) p.catch(function(){});
      }
    });
  }

  // sticky add to cart + floating ATC reveal
  var satc = document.getElementById('satc');
  var floatAtc = document.getElementById('floatAtc');
  var floatClose = document.getElementById('floatAtcClose');
  var buy = document.querySelector('.buy');

  // The floating pill's CTA scrolls up to the main pricing/options block
  // instead of adding to cart — gives the shopper a chance to pick Subscribe
  // vs One-time deliberately before committing.
  var floatBtnScroll = document.getElementById('btn-add-to-cart-float');
  if(floatBtnScroll){
    floatBtnScroll.addEventListener('click', function(){
      var target = document.getElementById('optbox') || document.querySelector('.buy');
      if(!target) return;
      // Account for any sticky site header: 90px cushion feels right.
      var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
    });
  }

  // ===== Escape the Shopify theme wrapper =====
  // If any ancestor has `transform`, `filter`, `perspective`, `will-change` or
  // `contain` set, it becomes the containing block for `position: fixed`
  // children — which pins the floater to the end of that wrapper (usually the
  // footer) instead of to the viewport. Moving the node to <body> dodges that.
  if(floatAtc && floatAtc.parentNode !== document.body){
    document.body.appendChild(floatAtc);
  }

  // User-dismissed state stays for the session only.
  var floatDismissed = false;
  if(floatClose && floatAtc){
    floatClose.addEventListener('click', function(){
      floatDismissed = true;
      floatAtc.classList.remove('show');
    });
  }

  // Track two signals, show the floater when BOTH say "show":
  //   buyVisible   — true while the main buy column is in the viewport
  //   pastHero     — true once the user has scrolled a bit (so it doesn't blast
  //                  at the top of the page). ~280px covers short preview panes
  //                  while still staying out of the way on the hero.
  var buyVisible = false;
  var pastHero   = false;

  function toggleFloaters(){
    var show = !buyVisible && pastHero;
    if(floatAtc && !floatDismissed){ floatAtc.classList.toggle('show', show); }
  }

  if(buy && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        buyVisible = en.isIntersecting;
        toggleFloaters();
      });
    }, {rootMargin:'-120px 0px 0px 0px'});
    io.observe(buy);
  } else {
    // Fallback for very old browsers — don't hide the floater by this signal.
    buyVisible = false;
  }

  // Scroll-threshold trigger. Works even if .buy never leaves view
  // (e.g. a tall right-column layout) and ensures the pill is visible in
  // short previews after just a nudge of scrolling.
  var onScroll = function(){
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var next = y > 280;
    if(next !== pastHero){ pastHero = next; toggleFloaters(); }
  };
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll(); // initialize immediately

  // (The floating ATC's price label is kept in sync by the pack-picker
  // handlers above — they call updateFloatPrice() on every selection.)
})();

(function(){
  var lb = document.getElementById('rvLb');
  if(!lb) return;
  var img = lb.querySelector('.rv-lb-img');
  var counter = lb.querySelector('.rv-lb-counter');
  var btnClose = lb.querySelector('.rv-lb-close');
  var btnPrev = lb.querySelector('.rv-lb-prev');
  var btnNext = lb.querySelector('.rv-lb-next');

  // Hero gallery tiles (top-of-reviews collage)
  var heroTiles = Array.prototype.slice.call(document.querySelectorAll('.rv-gallery .rv-tile img'));
  // Individual review photos (single images + mosaic tiles). Excludes video tiles.
  var reviewTiles = Array.prototype.slice.call(document.querySelectorAll('.rv-media:not(.rv-media-ph):not(.rv-media-video) > img, .rv-media .rv-m-tile img'));

  if(!heroTiles.length && !reviewTiles.length) return;

  var activeSet = heroTiles.length ? heroTiles : reviewTiles;
  var idx = 0;
  var lastFocus = null;

  function render(){
    var src = activeSet[idx].getAttribute('src');
    var alt = activeSet[idx].getAttribute('alt') || '';
    img.classList.add('is-loading');
    var pre = new Image();
    pre.onload = pre.onerror = function(){
      img.src = src;
      img.alt = alt;
      img.classList.remove('is-loading');
    };
    pre.src = src;
    counter.textContent = (idx + 1) + ' / ' + activeSet.length;
  }
  function open(set, i){
    activeSet = set;
    idx = i;
    lastFocus = document.activeElement;
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden','false');
    document.body.classList.add('rv-lb-locked');
    render();
    setTimeout(function(){ btnClose.focus(); }, 50);
  }
  function close(){
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden','true');
    document.body.classList.remove('rv-lb-locked');
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function next(){ idx = (idx + 1) % activeSet.length; render(); }
  function prev(){ idx = (idx - 1 + activeSet.length) % activeSet.length; render(); }

  // Hero gallery tiles, wire to lightbox with hero set
  heroTiles.forEach(function(t, i){
    var tile = t.closest('.rv-tile');
    if(!tile) return;
    tile.setAttribute('role','button');
    tile.setAttribute('tabindex','0');
    tile.setAttribute('aria-label','Open photo ' + (i+1) + ' of ' + heroTiles.length);
    tile.addEventListener('click', function(){ open(heroTiles, i); });
    tile.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); open(heroTiles, i); }
    });
  });

  // Individual review photos, wire to lightbox with review set
  reviewTiles.forEach(function(t, i){
    // Clickable region = closest tile wrapper if it's a mosaic cell, otherwise the img itself
    var target = t.closest('.rv-m-tile') || t;
    target.style.cursor = 'zoom-in';
    target.setAttribute('role','button');
    target.setAttribute('tabindex','0');
    target.setAttribute('aria-label','Open review photo ' + (i+1) + ' of ' + reviewTiles.length);
    target.addEventListener('click', function(){ open(reviewTiles, i); });
    target.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); open(reviewTiles, i); }
    });
  });

  btnClose.addEventListener('click', close);
  btnNext.addEventListener('click', next);
  btnPrev.addEventListener('click', prev);

  // Click outside the image closes
  lb.addEventListener('click', function(e){
    if(e.target === lb) close();
  });

  // Keyboard navigation
  document.addEventListener('keydown', function(e){
    if(!lb.classList.contains('is-open')) return;
    if(e.key === 'Escape') close();
    else if(e.key === 'ArrowRight') next();
    else if(e.key === 'ArrowLeft') prev();
  });

  // Touch swipe
  var tStartX = 0, tStartY = 0;
  lb.addEventListener('touchstart', function(e){
    if(e.touches.length !== 1) return;
    tStartX = e.touches[0].clientX;
    tStartY = e.touches[0].clientY;
  }, {passive:true});
  lb.addEventListener('touchend', function(e){
    if(e.changedTouches.length !== 1) return;
    var dx = e.changedTouches[0].clientX - tStartX;
    var dy = e.changedTouches[0].clientY - tStartY;
    if(Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)){
      if(dx < 0) next(); else prev();
    }
  }, {passive:true});
})();

/* ===== SPEED FIX: only load + play videos when they scroll into view ===== */
(function(){
  var vids = document.querySelectorAll('video[data-lazy-autoplay]');
  if (!vids.length) return;
  function start(v){ if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
  if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      var v = en.target;
      if (en.isIntersecting) start(v); else { try { v.pause(); } catch(e){} }
    });
  }, { rootMargin: '300px 0px', threshold: 0.01 });
  vids.forEach(function(v){ io.observe(v); });
})();


   /* ===== SPEED FIX: load review video preview only when it's close ===== */
   (function(){
     var vids = document.querySelectorAll('video[data-lazy-preload]');
     if (!vids.length) return;
     if (!('IntersectionObserver' in window)) { vids.forEach(function(v){ v.preload = 'metadata'; }); return; }
     var io = new IntersectionObserver(function(entries){
       entries.forEach(function(en){
         if (en.isIntersecting) { en.target.preload = 'metadata'; io.unobserve(en.target); }
       });
     }, { rootMargin: '600px 0px' });
     vids.forEach(function(v){ io.observe(v); });
   })();